import React, { useState } from "react";
import { Button, Icon, Confirm, Popup } from "semantic-ui-react";
import { BasicModal } from "../../../Shared";
import { Role } from "../../../../api";
import { useAuth } from "../../../../hooks";
import { RoleForm } from "../RoleForm";
import { RolePermissionForm } from "../RolePermissionForm";
import "./RoleItem.scss";

const roleController = new Role();

export function RoleItem(props) {
  const { role, onReload } = props;
  const { accessToken } = useAuth();

  const [showModal, setShowModal] = useState(false);
  const [showModalSubject, setShowModalSubject] = useState(false);
  const [titleModal, setTitleModal] = useState("");

  const [showConfirm, setShowConfirm] = useState(false);
  const [confirmMessage, setConfirmMessage] = useState("");

  const onOpenCloseModal = () => setShowModal((prevState) => !prevState);
  const onOpenCloseModalSubject = () =>
    setShowModalSubject((prevState) => !prevState);
  const onOpenCloseConfirm = () => setShowConfirm((prevState) => !prevState);

  const openRolePermissionManagement = () => {
    setTitleModal(`Gestionar permisos de: ${role.name}`);
    onOpenCloseModalSubject();
  };

  const openUpdateRole = () => {
    setTitleModal(`Actualizar tipo de usuario: ${role.name}`);
    onOpenCloseModal();
  };

  const openDeleteConfirm = () => {
    setConfirmMessage(`¿Eliminar la tipo de usuario ${role.name}?`);
    onOpenCloseConfirm();
  };

  const onDelete = async () => {
    try {
      await roleController.deleteRole(role.id);
      onReload();
      onOpenCloseConfirm();
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      <div className="role-item">
        <div className="role-item__info">
          <span className="role-item__info-name">{role.name}</span>
        </div>
        <div>
          <Popup
            content="Gestionar permisos"
            trigger={
              <Button icon color="green" onClick={openRolePermissionManagement}>
                <Icon name="key" />
              </Button>
            }
          />
          <Popup
            content="Actualizar tipo de usuario"
            trigger={
              <Button icon primary onClick={openUpdateRole}>
                <Icon name="pencil" />
              </Button>
            }
          />
          <Popup
            content="Eliminar tipo de usuario"
            trigger={
              <Button icon color="red" onClick={openDeleteConfirm}>
                <Icon name="trash" />
              </Button>
            }
          />
        </div>
      </div>
      <BasicModal
        size={"large"}
        scrolling={false}
        show={showModalSubject}
        close={onOpenCloseModalSubject}
        title={titleModal}
      >
        <RolePermissionForm
          onClose={onOpenCloseModalSubject}
          role={role}
        />
      </BasicModal>
      <BasicModal show={showModal} close={onOpenCloseModal} title={titleModal}>
        <RoleForm
          onClose={onOpenCloseModal}
          onReload={onReload}
          role={role}
        />
      </BasicModal>
      <Confirm
        confirmButton="Aceptar"
        cancelButton="Cancelar"
        open={showConfirm}
        onCancel={onOpenCloseConfirm}
        onConfirm={onDelete}
        content={confirmMessage}
        size="mini"
      />
    </>
  );
}
